import React, { useState, useCallback, useEffect, useRef } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./getCropping";
import { styles } from "./styles";
import { Alert, Button, Slider, Typography, IconButton } from "@mui/material";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";

import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";

const CropImageComponent = ({ classes, _callback, img, modal, setModal }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  const savingRef = useRef(false);

  useEffect(() => {
    setCrop({ x: 0, y: 0 });
    setRotation(0);
    setZoom(1);
    setCroppedAreaPixels(null);
    setError(false);
  }, [img]);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    if (!img || !croppedAreaPixels || savingRef.current) return;
    savingRef.current = true;
    setSaving(true);
    setError(false);
    try {
      const croppedImage = await getCroppedImg(
        img,
        croppedAreaPixels,
        rotation
      );
      await _callback(croppedImage);
      setModal(false);
    } catch {
      setError(true);
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  }, [croppedAreaPixels, rotation, img, setModal, _callback]);

  return (
    <Dialog
      open={modal}
      fullWidth
      maxWidth="md"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        className="d-flex justify-content-between align-items-center"
      >
        You have to crop image before submitting
        <IconButton aria-label="Закрыть обрезку" disabled={saving} onClick={() => setModal(false)}>
          <IoIosCloseCircleOutline />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div className={classes.cropContainer}>
          <Cropper
            image={img}
            cropShape="round"
            crop={crop}
            rotation={rotation}
            zoom={zoom}
            aspect={1}
            onCropChange={setCrop}
            onRotationChange={setRotation}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </div>
        <div className={classes.controls}>
          <div className={classes.sliderContainer}>
            <Typography
              variant="overline"
              classes={{ root: classes.sliderLabel }}
            >
              Zoom
            </Typography>
            <Slider
              disabled={saving}
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              aria-labelledby="Zoom"
              classes={{ root: classes.slider }}
              onChange={(e, zoom) => setZoom(zoom)}
            />
          </div>

          {error && <Alert severity="error" className="my-3">
            Не удалось сохранить фото. Проверьте изображение и соединение, затем повторите попытку.
          </Alert>}

          <Button
            onClick={showCroppedImage}
            variant="contained"
            color="primary"
            classes={{ root: classes.cropButton }}
            disabled={saving || !img || !croppedAreaPixels}
          >
            {saving ? "Сохранение…" : "Сохранить фото"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const CropImage = withStyles(styles)(CropImageComponent);

export default CropImage;
